export const onlyUnique = (value: any, index: any, self: any) => {
  return self.indexOf(value) === index;
};
